import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                d='M15.75 18.75L9 12.375L15.75 6'
                fill='transparent'
                stroke='currentColor'
                strokeWidth='2.75'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </SvgIcon>
    );
});
